module.exports = "https://static.wmbcdn.com/uniweb/images/72fd3ffe00d65ce703a9ccfc470d95f9.svg";